"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcludeCurrentPeriodToggleLabel = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var i18n_1 = require("../constants/i18n");
exports.ExcludeCurrentPeriodToggleLabel = function (props) {
    var id = !props.disabled && props.granularity
        ? "filters." + i18n_1.granularityIntlCodes[props.granularity] + ".excludeCurrentPeriod"
        : "filters.allTime.excludeCurrentPeriod";
    return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: id }, function () {
        var children = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            children[_i] = arguments[_i];
        }
        return react_1.default.createElement("span", { className: "input-label-text" }, children);
    }));
};
//# sourceMappingURL=ExcludeCurrentPeriodToggleLabel.js.map